import { render } from "./ValidationErrors.vue?vue&type=template&id=6d3cd730&ts=true"
import script from "./ValidationErrors.vue?vue&type=script&lang=ts"
export * from "./ValidationErrors.vue?vue&type=script&lang=ts"

import exportComponent from "/home/satou/deinjobfuchs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__